export default __webpack_public_path__ + "static/media/close.9d38e02c.svg";